export default __webpack_public_path__ + "static/media/img06.bd8339fd.webp";